<template>
  <el-main :style="{height:height+'px'}" v-infinite-scroll="load" infinite-scroll-disabled="disabled">
    <div class="Scroll_content">
      <div>
        <div class="simkeropl">{{$t('Transaction.History')}}</div>

            <div class="table_name mg_bottom">
                <div class="table_name">{{$t('Transaction.Order')}}</div>
                <div class="table_name">{{$t('Transaction.Date')}}</div>
                <!-- <div class="table_name">{{$t('Transaction.Description')}}</div> -->
                <div class="table_name">{{$t('Transaction.Paid')}}</div>
                <div class="table_name">{{$t('Transaction.Status')}}</div>
            </div>



            <div class="table_name height_content" v-for="(item,index) in lessonData" :key="index">
                <div class="table_name font">{{item.order_no}}</div>
                <div class="table_name font">{{item.date}}</div>
                <!-- <div class="table_name font">{{item.description?item.description:'-'}}</div> -->
                <div class="table_name font">${{item.amount}}</div>
                <div class="table_name font">{{item.pay_status}}</div>
            </div>
        <p v-if="loading" style="margin-top:20px;text-align:center;" class="loading">
          <span></span>
        </p>
        <p v-if="noMore" style="margin-top:30px;font-size:18px;color:#ccc;text-align:center;margin-bottom:20px;"> {{$t('Nomore')}}</p>
        <div class="dian mgb"></div>
      </div>
    </div>

  </el-main>
  
</template>
<script>
  import { setStore, getStore, keys } from '@/store';
  import IndexHeader from '../views/header'
  import IndexFooter from '../views/footer'
  import MyScheduled from '../views/scheduled'
  import MyCourse from '../views/course'
  import PastLesson from '../views/lesson'

  //引入header组件
  import Header from '../header/header'

  export default {
    components: {
      IndexHeader,
      IndexFooter,
      MyScheduled,
      PastLesson,
      MyCourse,
      Header
    },
    data () {
      return {
          height:100,

          lessonData:[],//后端返回数据
          count: 1,//起始页数值为0
          loading: false,
          totalPages: "",//取后端返回内容的总页数
      }
    },
    created () {
      let height = document.body.offsetHeight-80;
      this.height = height;
      if (getStore(keys.token)) {
        if (getStore(keys.userInfo).status == 0) {
          this.$router.push({
            path: '/sinadd'
          })
        }
      } else {
        this.$router.push({
          path: '/'
        })
        return false
      }
      this.get_Bill_all();
    },
    computed: {
      noMore() {
        //当起始页数大于总页数时停止加载
        console.log(this.count,this.totalPages);
        return this.count >= this.totalPages + 1;
      },
      disabled() {
        return this.loading || this.noMore;
      }
    },
    methods: {
      load() {
        //滑到底部时进行加载
        this.loading = true;
        setTimeout(() => {
          //页数+1
          this.count += 1; 
          //调用接口，此时页数+1，查询下一页数据
          this.get_Bill_all(); 
        }, 2000);
      },
      // pagesize='+this.pagesize+'&page='+this.page
      /**
       * 分页加载数据方法
       */
      get_Bill_all:function(){
        this.$http.get('/api/getChargesList?pagesize=10&page='+this.count).then((res) => {
          if (res.data.code == 200) {
            console.log(999,res);
            this.lessonData = this.lessonData.concat(res.data.data.data_info);
            this.totalPages = Math.ceil(res.data.data.total / 10);
            this.loading = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      }

      
    },
    mounted () {

    },
    watch: {

    },
  }
</script>
<style lang="less" scoped>

.simkeropl{
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: bold;
    font-size: 33px;
    color: #000000;
    display: flex;
    margin-bottom:40px;
}
.table_name{
    width: 100%;
    height: auto;
    display: flex;
    // margin-top:40px;
    .table_name_one{
        height: 40px;
        flex:1;
        border:0px solid red;
    }
    .table_name{
        // height: 40px;
        flex:1;
        border:0px solid red;
        font-family: Poppins;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #A5A5A5;
        align-items: center;
        justify-content: center;
    }   
}
.height_content{
    height: 90px !important;
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    margin-bottom:15px;
}
.mg_bottom{
    margin-bottom:8px;
}
.font{
    font-family: Poppins !important;
    font-style: normal !important;
    font-weight: normal !important;
    font-size: 16px !important;
    line-height: 16px !important;
    /* or 100% */
    color: #000000 !important;
}
.loading span {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid #409eff;
  border-left: transparent;
  animation: zhuan 0.5s linear infinite;
  border-radius: 50%;
}
@keyframes zhuan {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/children/Transaction.vue